import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ca5a736"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "split-layout-container" }
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, null, -1))
const _hoisted_4 = { class: "form-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, null, -1))

import { FormKitNode, getNode } from '@formkit/core'
import { useI18n } from 'vue-i18n'
import postalCodeRegexes from 'zipcodes-regex'
import countryCodes, { countryCodesWithoutPostalCodes } from '@grantstreet/psc-vue/utils/country-codes.js'
import stateCodes from '@grantstreet/psc-vue/utils/state-codes.js'
import { getUsStateFromZip } from '@grantstreet/psc-js/utils/addresses.js'
import { FormKitValidationMessage } from '@formkit/validation'
import { computed, onMounted, onBeforeUnmount, ref, nextTick } from 'vue'
import { v4 } from 'uuid'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormKitAddress',
  props: {
    label: { default: 'Address' },
    allowInternational: { type: Boolean, default: true },
    name: { default: 'address' }
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n()

const uuid = v4()
const countryId = `country-${uuid}`
const stateId = `state-${uuid}`
const postalCodeId = `postal-code-${uuid}`



const countryOptions = computed(() => {
  const countries = props.allowInternational
    ? Object.values(countryCodes)
    : [ countryCodes.US ]

  return countries.map(({ code, name }) => ({
    value: code,
    label: name,
  }))
})

const stateOptions = stateCodes.map(({
  name,
  code,
}: {
  name: string
  code: string
}) => ({
  value: code,
  label: name,
}))

const postalCodeRequired = ref(true)

const postalCodeValidations = computed(() => {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
   * This is a FormKit type and uses `any` */
  const validations: [rule: string, ...args: any[]][] = [
    ['length', '0', '10'],
    ['validPostalCode'],
  ]
  if (postalCodeRequired.value) {
    validations.push(['required'])
  }
  return validations
})

function validPostalCode (node: FormKitNode) {
  const postalCodeValue = (node.value as string).trim()
  const country = (getNode(countryId)?.value || 'US') as keyof typeof postalCodeRegexes

  const regex = postalCodeRegexes[country]
  if (regex) {
    return new RegExp(String(regex), 'i').test(postalCodeValue)
  }

  // If we don't know how to validate this country, assume it's valid
  return true
}

const postalCodeValidationMessage: FormKitValidationMessage = ({
  node,
}) => {
  const formCountry = node.at(countryId)?.value as keyof typeof countryCodes

  const { name: country, code, format } = countryCodes[formCountry] || {}

  return (format && country)
    ? t('postal-code.formatting', { country, format })
    : t('postal-code.invalid', { countryCode: code })
}

function guessState () {
  const country = getNode(countryId)?.value
  if (country !== 'US') {
    return
  }
  const postalCode = getNode(postalCodeId)?.value
  const guessedState = getUsStateFromZip(postalCode)
  if (!guessedState) {
    return
  }

  getNode(stateId)?.input(guessedState)
}

onMounted(() => {
  getNode(countryId)?.on('commit', async ({ payload }) => {
    postalCodeRequired.value = !countryCodesWithoutPostalCodes.includes(payload)

    // Wait for the US state dropdown to render, then try to auto-select the
    // appropriate state
    await nextTick()
    guessState()
  })
  getNode(postalCodeId)?.on('commit', () => {
    guessState()
  })
})

onBeforeUnmount(() => {
  getNode(countryId)?.off('commit')
  getNode(postalCodeId)?.off('commit')
})

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FormKit, {
      type: "group",
      name: _ctx.name
    }, {
      default: _withCtx(({ value }) => [
        _createVNode(_component_FormKit, {
          type: "text",
          name: "address1",
          placeholder: _unref(t)('address-1.label'),
          "validation-label": _unref(t)('address-1.label'),
          label: _ctx.label,
          autocomplete: "address-line1",
          validation: [
          ['required'],
          ['length', '0', '49'],
        ]
        }, null, 8, ["placeholder", "validation-label", "label"]),
        _createVNode(_component_FormKit, {
          type: "text",
          name: "address2",
          placeholder: _unref(t)('address-2.placeholder'),
          "validation-label": _unref(t)('address-2.label'),
          autocomplete: "address-line2",
          validation: [
          ['length', '0', '49'],
        ]
        }, null, 8, ["placeholder", "validation-label"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_FormKit, {
              type: "text",
              name: "city",
              placeholder: _unref(t)('city.label'),
              "validation-label": _unref(t)('city.label'),
              autocomplete: "address-level2",
              validation: [
              ['required'],
              ['length', '0', '50'],
            ],
              "outer-class": {
              'col-md-5': true,
              'align-self-start': true,
            },
              "wrapper-class": {
              'form-row': false,
            },
              "inner-class": {
              'col-md-8': false,
            },
              "messages-class": {
              'form-row': false,
            },
              "message-class": {
              'col-md-8': false,
              'offset-md-4': false,
            }
            }, null, 8, ["placeholder", "validation-label"]),
            (value?.country === 'US')
              ? (_openBlock(), _createBlock(_component_FormKit, {
                  key: 0,
                  id: stateId,
                  type: "select",
                  name: "state",
                  placeholder: _unref(t)('state.placeholder'),
                  "validation-label": _unref(t)('state.label'),
                  options: _unref(stateOptions),
                  autocomplete: "address-level1",
                  validation: "required",
                  "outer-class": {
              'col-md-3': true,
              'align-self-start': true,
            },
                  "wrapper-class": {
              'form-row': false,
            },
                  "inner-class": {
              'col-md-8': false,
            },
                  "messages-class": {
              'form-row': false,
            },
                  "message-class": {
              'col-md-8': false,
              'offset-md-4': false,
            }
                }, null, 8, ["placeholder", "validation-label", "options"]))
              : (_openBlock(), _createBlock(_component_FormKit, {
                  key: 1,
                  type: "text",
                  name: "state",
                  placeholder: _unref(t)('state.label'),
                  "validation-label": _unref(t)('state.label'),
                  autocomplete: "address-level1",
                  validation: [
              ['required'],
              ['length', '0', '20'],
            ],
                  "outer-class": {
              'col-md-3': true,
              'align-self-start': true,
            },
                  "wrapper-class": {
              'form-row': false,
            },
                  "inner-class": {
              'col-md-8': false,
            },
                  "messages-class": {
              'form-row': false,
            },
                  "message-class": {
              'col-md-8': false,
              'offset-md-4': false,
            }
                }, null, 8, ["placeholder", "validation-label"]))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_FormKit, {
              id: postalCodeId,
              type: "text",
              name: "postalCode",
              placeholder: _unref(t)('postal-code.label'),
              "validation-label": _unref(t)('postal-code.label'),
              autocomplete: "postal-code",
              validation: postalCodeValidations.value,
              "validation-rules": { validPostalCode: validPostalCode },
              "validation-messages": {
              validPostalCode: postalCodeValidationMessage,
            },
              "outer-class": {
              'col-md-3': true,
              'align-self-start': true,
            },
              "wrapper-class": {
              'form-row': false,
            },
              "inner-class": {
              'col-md-8': false,
            },
              "messages-class": {
              'form-row': false,
            },
              "message-class": {
              'col-md-8': false,
              'offset-md-4': false,
            }
            }, null, 8, ["placeholder", "validation-label", "validation", "validation-rules", "validation-messages"]),
            _createVNode(_component_FormKit, {
              id: countryId,
              type: "select",
              name: "country",
              placeholder: _unref(t)('country.placeholder'),
              "validation-label": _unref(t)('country.label'),
              options: countryOptions.value,
              value: "US",
              validation: "required",
              "outer-class": {
              'col-md-5': true,
              'align-self-start': true,
            },
              "wrapper-class": {
              'form-row': false,
            },
              "inner-class": {
              'col-md-8': false,
            },
              "messages-class": {
              'form-row': false,
            },
              "message-class": {
              'col-md-8': false,
              'offset-md-4': false,
            }
            }, null, 8, ["placeholder", "validation-label", "options"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["name"])
  ]))
}
}

})